// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"sectionHeader_sectionHeader__1Xfdx","title":"sectionHeader_title__GKflM"};